/*--------------------------------------------------------------
    TOP MENU HEIGHT CALC
--------------------------------------------------------------*/

(function ($, Drupal, drupalSettings, once) {

  Drupal.behaviors.customVhCalc = {

    attach: function (context, settings) {

      once('navbarContentOffsetCalc', 'html').forEach(function (element) {

        const mainMenu = document.querySelector('.main-menu');
        const topMenu = document.querySelector('.top-menu');

        const navbarContentOffsetCalc = () => {

          let navbarContentOffset = 0;

          if (mainMenu && getComputedStyle(mainMenu).position === 'sticky') {
            navbarContentOffset += mainMenu.offsetHeight;
          }

          if (topMenu && getComputedStyle(topMenu).position === 'sticky') {
            navbarContentOffset += topMenu.offsetHeight;
          }

          document.documentElement.style.setProperty('--navbar-content-offset', `${navbarContentOffset}px`);
        }

        if (mainMenu || topMenu) {
          // Trigger topMenuHeightCalc function on page load
          navbarContentOffsetCalc();

          // Trigger topMenuHeightCalc function on window resize
          window.addEventListener('resize', () => {
            navbarContentOffsetCalc();
          });
        }
      });
    }
  }

} (jQuery, Drupal, drupalSettings, once));

